import React from "react";

/**
 * Controlled numeric input for money amounts.
 *
 * Fixes:
 * - Default state of `0` would trap a leading zero (e.g. typing 10000 → "010000").
 *   We accept a string value and strip leading zeros on change, so the initial
 *   value can be "" (empty placeholder) or any numeric string the parent chose.
 * - Auto-selects content on focus so users can overwrite without manual clearing.
 *
 * Parent must manage state as a string and parse with `parseFloat(value) || 0`
 * on submit.
 */
export default function MoneyInput({ value, onChange, className, ...rest }) {
    const handleChange = (e) => {
        let v = e.target.value;
        // Strip leading zeros unless value is "0", "0.", "0,", "0.xx" etc.
        if (/^0\d/.test(v)) {
            v = v.replace(/^0+/, "");
        }
        onChange(v);
    };

    const handleFocus = (e) => {
        // Select all so typing replaces the value cleanly.
        e.target.select();
    };

    return (
        <input
            type="number"
            step="0.01"
            inputMode="decimal"
            value={value ?? ""}
            onChange={handleChange}
            onFocus={handleFocus}
            className={className}
            {...rest}
        />
    );
}
